import * as React from 'react';

function SvgSaveEnergyNight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" {...props}>
      <path
        className="saveEnergyNight_svg__st0"
        d="M62.1 10.5c-2.9-3.5-6.5-6-10.3-7.8 4.3 13 .6 28.3-10.5 38.4S15.1 53.5 3.1 47.8c1.4 4.1 3.5 8.1 6.5 11.4 12.3 14.1 34.1 14.7 48.7 1.3 14.3-13.5 16.1-36 3.8-50"
      />
      <path
        className="saveEnergyNight_svg__st0"
        d="M27.1 19.4c0-.6.7-1.1 1.6-1.1h4.4c.9 0 1.6.5 1.6 1.1s-.7 1.1-1.6 1.1h-4.4c-.9 0-1.6-.4-1.6-1.1zM1.3 19.4c0-.6.7-1.1 1.6-1.1h4.4c.9 0 1.6.5 1.6 1.1s-.7 1.1-1.6 1.1H2.8c-.8 0-1.5-.4-1.5-1.1zM16.9 4.3c0-.9.5-1.6 1.1-1.6.6 0 1.1.7 1.1 1.6V9c0 .9-.5 1.6-1.1 1.6-.6 0-1.1-.7-1.1-1.6V4.3zM16.9 30c0-.9.5-1.6 1.1-1.6.6 0 1.1.7 1.1 1.6v4.7c0 .9-.5 1.6-1.1 1.6-.6 0-1.1-.7-1.1-1.6V30zM25.3 19.5c0 4-3.3 7.2-7.4 7.2s-7.4-3.2-7.4-7.2 3.3-7.2 7.4-7.2c4 0 7.4 3.2 7.4 7.2zM24.6 27.9c-.6-.6-.8-1.4-.4-1.9.4-.4 1.2-.2 1.8.4l3.3 3.4c.6.6.8 1.4.4 1.9s-1.2.2-1.8-.4l-3.3-3.4zM8 31.3c-.6.6-1.4.8-1.8.4-.4-.4-.2-1.2.4-1.9l3.3-3.4c.6-.6 1.4-.8 1.8-.4.4.4.2 1.2-.4 1.9L8 31.3zM5.8 9.2c-.7-.6-.8-1.4-.4-1.9.4-.4 1.2-.2 1.8.4l3.3 3.4c.6.6.8 1.4.4 1.9s-1.2.2-1.8-.4L5.8 9.2zM26.4 12.9c-.6.6-1.4.8-1.8.4-.4-.4-.2-1.2.4-1.9L28.3 8c.6-.6 1.4-.8 1.8-.4.4.4.2 1.2-.4 1.9l-3.3 3.4z"
      />
    </svg>
  );
}

export default SvgSaveEnergyNight;
